const socialNetworks = [
  {
    name: "youtube",
    id: "Schoolofproficiency",
    link: "https://youtube.com/c/Schoolofproficiency",
    icon: "youtube",
  },
  {
    name: "website",
    id: "marveltrade.org",
    link: "https://marveltrade.org/",
    icon: "globe2",
  },
  {
    name: "instagram",
    id: "marvel_tradee",
    link: "https://instagram.com/marvel_tradee?utm_medium=copy_link",
    icon: "instagram",
  },
  {
    name: "telegram",
    id: "marveltradegroup",
    link: "https://t.me/marveltradegroup",
    icon: "telegram",
  },
];
export default socialNetworks;
